// extracted by mini-css-extract-plugin
export default {"select":"FormTimeSelect_select__F7ZVf","lgSelect":"FormTimeSelect_lgSelect__rZBU+"};